// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___zrz2F","root__header":"style-module__root__header___MsCR_","root__header_active":"style-module__root__header_active___xwfCz","root__wrapper":"style-module__root__wrapper___U2e2r","root__wrapper_title":"style-module__root__wrapper_title___gQ9xH","root__fee":"style-module__root__fee___l3Hkm","root__amount":"style-module__root__amount___Z7mOx","root__percentage":"style-module__root__percentage___AOPrK","root__infinity":"style-module__root__infinity___rqAMv"};
    if(module.hot) {
      // 1697460472172
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  